import React, { useState, useEffect } from "react";
import Logo from "assets/logo.svg";
import { useLocation, useNavigate } from "react-router-dom";

export default function TopBar() {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Clear any existing timeout
      clearTimeout(timeoutId);

      // Hide when scrolling down, show when scrolling up
      if (currentScrollY > lastScrollY && currentScrollY > 10) {
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY) {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    const handleMouseMove = (e) => {
      // Show topbar when mouse moves to top 100px of screen
      if (e.clientY <= 100 && !isVisible) {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("mousemove", handleMouseMove, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("mousemove", handleMouseMove);
      clearTimeout(timeoutId);
    };
  }, [lastScrollY, isVisible]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "65px",
        justifyContent: "space-between",
        padding: "0px 62px",
        background: "linear-gradient(180deg, #AFE0C1 0%, #FFFFFF 100%)",
        position: "fixed",
        top: 0,
        zIndex: 100,
        width: "calc(100vw - 124px)",
        transform: isVisible ? "translateY(0)" : "translateY(-100%)",
        opacity: isVisible ? 1 : 0,
        transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
      }}
    >
      <div
        onClick={() => {
          if (loc.pathname !== "/") nav("/");
        }}
        style={{ cursor: "pointer" }}
      >
        <img src={Logo} alt="Logo" width={"234px"} style={{ display: "block" }} />
      </div>
    </div>
  );
}
